/***
 * SP HAMBURGER MENU
 */
const hamburger = document.querySelector('.hamburger')
console.log(hamburger)
hamburger.addEventListener('click', () => {
    document.body.classList.toggle('nav-is-open')
})


/***
 * SP Navigation panel
 */
const subMenu = document.querySelector(".menu-sub");

subMenu.addEventListener("click", function() {
    document.body.classList.toggle('menu-is-open')
    const panel = document.querySelector(".submenu");
    if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
    } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
    }
});
